import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui//styles';

const useStyles = makeStyles(theme => ({
    active: {
        backgroundColor: theme.palette.action.selected
    }
}))

const SidebarItems = () => {
    const classes = useStyles()
    return (
        <>
            <ListItem button component={NavLink} to='/dashboard' activeClassName={classes.active}>
                <ListItemIcon>
                    <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="داشبورد" />
            </ListItem>

            <ListItem button component={NavLink} to='/accounts' activeClassName={classes.active}>
                <ListItemIcon>
                    <AccountBalanceIcon />
                </ListItemIcon>
                <ListItemText primary="حساب ها" />
            </ListItem>

            <ListItem button component={NavLink} to='/banks' activeClassName={classes.active}>
                <ListItemIcon>
                    <AccountBalanceIcon />
                </ListItemIcon>
                <ListItemText primary="بانک ها و شعب" />
            </ListItem>

            <ListItem button component={NavLink} to='/cheque_settings' activeClassName={classes.active}>
                <ListItemIcon>
                    <LocalAtmIcon />
                </ListItemIcon>
                <ListItemText primary="تنظیمات چک" />
            </ListItem>
        </>
    )
}

export default SidebarItems